"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrayLength;
var _utils = require("../utils");
var _lib = require("../lib");
function arrayLength(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertArray)(value);
  var message = options.message,
    min = options.min,
    max = options.max,
    equal = options.equal;
  var label = options.label || 'Field';
  var item = options.item || 'items';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var equalProp = parseInt(equal, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp, " ").concat(item);
  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value.length;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp, " ").concat(item);
  }
  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp, " ").concat(item);
  }
  if ((0, _utils.checkValueExist)(equal)) {
    (0, _utils.assertNumber)(equal, 'equal');
    // set all values same as equalProp
    minProp = maxProp = equalProp;
  } else {
    equalProp = 0;
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0) {
    var isEqual = equalProp > 0 && value.length !== equalProp;
    var isMin = equalProp < 1 && value.length < minProp;
    var isMax = equalProp < 1 && value.length > maxProp;
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      item: item,
      isEqual: isEqual,
      isMin: isMin,
      isMax: isMax
    };
    if (isEqual) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should be ").concat(equalProp, " ").concat(item));
    } else if (isMax || isMin) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
    }
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/arrayLength.js
// module id = 1867
// module chunks = 0